import React from 'react';
import { Search, SearchIconWrapper, StyledInputBase } from 'components';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import { IconButton, Tooltip } from 'components/mui';

interface CustomerSearchProps {
  searchInput: string;
  onSearchInput: (input: string) => void;
  onReset: () => void;
}

function CustomerSearch({ searchInput, onSearchInput, onReset }: CustomerSearchProps) {
  const onClick = () => {
    onSearchInput('');
    onReset();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputWord = e.target.value;
    onSearchInput(inputWord);
  };

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        placeholder="Search customers…"
        value={searchInput}
        onChange={onChange}
        endAdornment={
          searchInput ? (
            <Tooltip title="Clear">
              <IconButton onClick={onClick}>
                <CloseOutlinedIcon />
              </IconButton>
            </Tooltip>
          ) : null
        }
      />
    </Search>
  );
}

export default CustomerSearch;
